import { MACROTRENDS, MICROTRENDS } from '@/model/workspace/trends'

export default {
    [MACROTRENDS]: 'Macro-trends',
    [MICROTRENDS]: 'Micro-trends',
    sort: {
        label: 'Sort by',
        positionAsc: 'Individual order ↑',
        positionDesc: 'Individual order ↓',
        createdAtAsc: 'Added to work space ↑',
        createdAtDesc: 'Added to work space ↓',
        publishedAtAsc: 'Publication ↑',
        publishedAtDesc: 'Publication ↓',
        votingResultAsc: 'Votes ↑',
        votingResultDesc: 'Votes ↓'
    },
    bulk: {
        delete: 'Remove'
    },
    confirmation: {
        confirm: 'Yes, remove now',
        success: 'Trend has been removed from the work space successfully.|Trends have been removed from the work space successfully.',
        title: 'Are you sure you want to remove this trend from the work space "{title}"?|Are you sure you want to remove the selected trends from the work space "{title}"?'
    },
    votingControls: {
        upvoteTooltip: 'Vote for this trend',
        downvoteTooltip: 'Vote against this trend',
        unvoteTooltip: 'Undo vote'
    }
}
